// extracted by mini-css-extract-plugin
module.exports = {"container":"pagenavitem_container__2HoKC","item":"pagenavitem_item__1cN6y"};